<script setup lang="ts">
import { computed } from 'vue';
import { QLinearProgress } from 'quasar';
import { getTranslation, getLabel } from '@/utils/data-display-utils';
import { Locales } from '@/store/language.interface';

// PROPS
const props = defineProps<{
  choices: any;
  setActiveScreen?: string;
  statistiques: any;
  response?: any[];
  otherChoice: boolean;
  otherChoiceLabel?: string;
  languageEnabled?: Locales[];
  showStats?: boolean;
}>();

// COMPUTED
const selectedResponses = computed(() => {
  if (props.response) {
    return props.response[0].value_id;
  } else {
    return [];
  }
});

// FUNCTIONS
function isChoiceSelected(choiceId: number) {
  return selectedResponses.value.includes(choiceId);
}

function getProgressbarLabel(label: string, percentage?: number) {
  return percentage == null
    ? `${label} ${getLabel('form.no-votes', props.languageEnabled)}`
    : `${label} ${percentage}%`;
}
</script>
<template>
  <div class="image-results">
    <div v-for="choice in props.choices">
      <q-linear-progress
        size="100px"
        :value="props.showStats ? props?.statistiques?.[choice.id]?.percentage / 100 : undefined"
        :aria-label="
          getProgressbarLabel(
            getTranslation(choice, 'text', props.languageEnabled),
            props.statistiques?.[choice.id]?.percentage,
          )
        "
      >
        <div class="image-results__content">
          <div class="image-results__content-image">
            <img :src="choice.image?.url" alt="" role="presentation" />
            {{ getTranslation(choice, 'text', props.languageEnabled) }}
          </div>
          <div class="image-results__content-stat">
            <div v-if="isChoiceSelected(choice.id)" class="icon">
              <q-icon color="primary" size="sm" name="check_circle" />
            </div>
            <div class="label" v-if="props.statistiques?.[choice.id] && props.showStats">
              {{ props.statistiques?.[choice.id]?.percentage }}%
            </div>
          </div>
        </div>
      </q-linear-progress>
    </div>
  </div>
</template>
<style lang="scss">
.image-results {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .q-linear-progress {
    display: flex;
    align-items: center;
    background-color: $color-neutral-grey-200 !important;
    color: $color-primary-12;
    border-radius: 8px !important;
  }

  &__content {
    display: flex;
    justify-content: space-between;
    margin: $space-sm;
    height: 100%;
    width: 100%;
    gap: $space-md;

    &-image {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: $space-lg;
      position: relative;
      z-index: 2;
      font-size: $body-text;
      color: $color-primary-darken;
      overflow-wrap: anywhere;

      img {
        height: 80px;
        border-radius: 8px;
      }
    }

    &-stat {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: $space-sm;
      position: relative;
      z-index: 2;
      height: inherit;

      .icon {
        display: flex;
        align-items: center;
        height: inherit;
      }

      .label {
        font-size: $body-text;
        color: $color-primary-darken;
      }
    }
  }
}
</style>
